// extracted by mini-css-extract-plugin
export var filterForm = "PostsModuleMixedLayout-module--filterForm--pXZwq";
export var secondaryList = "PostsModuleMixedLayout-module--secondaryList--Srlig";